var map = {
	"./agenda-una-reunion/op_img-header-mobile.png": 2523,
	"./como-funciona/op_img-header-mobile.png": 1345,
	"./nuestra-propuesta/op_img-header-mobile.png": 2524,
	"./politicas/op_img-header-mobile.png": 2525,
	"./preguntas-frecuentes/op_img-header-mobile.png": 2526,
	"./quienes-somos/op_img-header-mobile.png": 2527,
	"./registro/op_img-header-mobile.png": 2528,
	"./tratamiento-datos/op_img-header-mobile.png": 2529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2522;